import React from 'react'

const IconBase = ({ color, size, style, width, height, ...props }) => {
  const computedSize = size || '1em'
  return (
    <svg
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      height={height || computedSize}
      width={width || computedSize}
      {...props}
      style={{
        verticalAlign: 'middle',
        color,
        ...style,
      }}
    />
  )
}

export default IconBase
